<template>
  <div class="flex items-center gap-1.5">
    <span class="text-sm text-slate-500 dark:text-slate-400">
      {{ currentText }}
    </span>
    <span
      v-if="isTyping"
      class="inline-block h-4 w-0.5 animate-pulse bg-slate-400 dark:bg-slate-500"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, watch, onMounted } from 'vue'
import { useRightyStore } from '../stores/rightyStore'
import { useTypewriter } from '../composables/useTypewriter'
import { getThinkingMessages } from '../config/thinkingMessages'

const rightyStore = useRightyStore()

// Get messages based on current context
const messages = computed(() => {
  const module = rightyStore.invocationContext?.module
  return getThinkingMessages(module)
})

// Initialize typewriter
const { currentText, isTyping, start, stop } = useTypewriter(messages, {
  typingSpeed: 30,
  pauseDuration: 1500
})

// Start animation on mount
onMounted(() => {
  start()
})

// Stop when component unmounts (handled by composable's onUnmounted)
</script>
